import _extends from '@babel/runtime-corejs3/helpers/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import classNames from 'classnames';
import styles from './786760d79122c282c758ecd73bc84aa3f02bdd5ae02cfeb9f9a8ca539f43a379.cfe-internal.js';

var _excluded = ["children", "className"];
var Table = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React__default.createElement("table", _extends({}, rest, {
    ref: ref,
    className: classNames(className, styles.table)
  }), children);
});
var Table$1 = Table;

export { Table$1 as default };
